<template>
  <input
    :type="type"
    :placeholder="placeholder"
    v-model="value"
    :disabled="disabled"
    @input="handleInput"
    @blur="handleBlur"
    @click="handleClick"
    @keydown.enter.exact.prevent
    @keyup.enter.exact="handleEnter"
    :maxlength="maxLength"
    autocomplete="new-password"
  />
</template>

<script>
import { replaceAddressChr, replaceSpecialChr } from '@/utils';

export default {
  model: {
    prop: 'value',
    event: 'custom-input',
  },
  props: {
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    target: {
      type: String,
      default: '',
    },
    maxLength: {
      type: Number,
      default: 1000,
    },
  },
  data() {
    return {
      value: '',
    };
  },

  methods: {
    handleInput(e) {
      // IE에서 placeholder 때문에 자동으로 trigger 되는 버그...
      if ('activeElement' in document && document.activeElement != e.target) return false;
      if (this.target === 'address' || this.target === 'businessName') {
        this.value = replaceAddressChr(e.target.value);
      } else if (this.target === 'email' || this.target === 'hypen') {
        this.value = e.target.value;
      } else if (this.target === 'birthday' && this.value.length > 8) {
        this.value = this.value.slice(0, 8);
      } else {
        this.value = replaceSpecialChr(e.target.value);
      }
      this.$emit('custom-input', this.value);
    },
    handleBlur() {
      if (this.target === 'birthday' && this.value.length === 8) {
        this.value = `${this.value.slice(0, 4)}/${this.value.slice(4, 6)}/${this.value.slice(6, 8)}`;
      }
      this.$emit('custom-blur');
    },
    handleClick() {
      if (this.target === 'birthday') {
        this.value = this.value.replace(/[/]/g, '');
      }
      this.$emit('custom-click');
    },
    handleEnter() {
      this.$emit('custom-enter');
    },
  },
};
</script>
